import React from 'react';
import styles from '../../styles/renewal/Forms.module.css';

/** 라벨 + 컨트롤 + 오류 메시지를 한 묶음으로 렌더한다. */
function Wrap({ id, label, required, error, children }) {
  return (
    <div className={styles.field}>
      <label className={`${styles.label} ${required ? styles.req : ''}`} htmlFor={id}>
        {label}
      </label>
      {children}
      {error ? (
        <span className={styles.error} id={`${id}-error`} role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}

function a11y(id, error) {
  return {
    id,
    'aria-invalid': error ? true : undefined,
    'aria-describedby': error ? `${id}-error` : undefined,
  };
}

export function TextField({ id, name, label, required, error, ...rest }) {
  return (
    <Wrap id={id} label={label} required={required} error={error}>
      <input
        className={`${styles.input} ${error ? styles.invalid : ''}`}
        name={name}
        {...a11y(id, error)}
        {...rest}
      />
    </Wrap>
  );
}

export function SelectField({ id, name, label, options, error, ...rest }) {
  return (
    <Wrap id={id} label={label} error={error}>
      <select
        className={`${styles.select} ${error ? styles.invalid : ''}`}
        name={name}
        {...a11y(id, error)}
        {...rest}
      >
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </Wrap>
  );
}

export function TextareaField({ id, name, label, required, error, ...rest }) {
  return (
    <Wrap id={id} label={label} required={required} error={error}>
      <textarea
        className={`${styles.textarea} ${error ? styles.invalid : ''}`}
        name={name}
        {...a11y(id, error)}
        {...rest}
      />
    </Wrap>
  );
}

export function AgreeField({ id, name, checked, onChange, onBlur, error, children }) {
  return (
    <div className={styles.field}>
      <label className={styles.agree} htmlFor={id}>
        <input
          className={styles.checkbox}
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          onChange={onChange}
          onBlur={onBlur}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? `${id}-error` : undefined}
        />
        <span>{children}</span>
      </label>
      {error ? (
        <span className={styles.error} id={`${id}-error`} role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}

/** 제출 결과 배너. 스크린리더에 즉시 읽히도록 live region 으로 둔다. */
export function StatusBanner({ status, successText, errorText }) {
  if (status !== 'success' && status !== 'error') return null;
  const ok = status === 'success';
  return (
    <div
      className={`${styles.status} ${ok ? styles.statusOk : styles.statusFail}`}
      role={ok ? 'status' : 'alert'}
    >
      {ok ? successText : errorText}
    </div>
  );
}
